import {
  ListSelectDTO,
  ListBoxPrenotazioneLaboratorioDTO,
} from '../../../../model/newModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsCLA } from '../../../../shared/constants-cla';
import {
  SearchPrenotazioneLaboratorioCommand,
  AddUpdateStudentePrenotazioneLaboratorioCommand,
} from 'src/app/model/command-model';

@Injectable({
  providedIn: 'root',
})
export class PrenotazioneLaboratorioService {
  constructor(private http: HttpClient) {}

  search(idTutor: number, dataCorrente: Date) {
    const command = new SearchPrenotazioneLaboratorioCommand();
    command.idTutor = idTutor;
    command.dataCorrente = dataCorrente;
    command.skip = 0;
    command.take = 4;
    return this.http.post<ListBoxPrenotazioneLaboratorioDTO>(
      ConstantsCLA.PRENOTAZIONE_LABORATORIO_SEARCH_URL,
      command
    );
  }

  previousPage(
    idTutor: number,
    dataCorrente: Date,
    skip: number,
    take: number
  ) {
    const skipNew = skip - 1 < 0 ? 0 : skip - 1;
    const command = new SearchPrenotazioneLaboratorioCommand();
    command.idTutor = idTutor;
    command.dataCorrente = dataCorrente;
    command.skip = skipNew;
    command.take = take;

    return this.http.post<ListBoxPrenotazioneLaboratorioDTO>(
      ConstantsCLA.PRENOTAZIONE_LABORATORIO_SEARCH_URL,
      command
    );
  }

  nextPage(
    idTutor: number,
    dataCorrente: Date,
    skip: number,
    take: number,
    count: number
  ) {
    const skipNew = skip + 1;
    const command = new SearchPrenotazioneLaboratorioCommand();
    command.idTutor = idTutor;
    command.dataCorrente = dataCorrente;
    command.skip = skipNew;
    command.take = take;

    return this.http.post<ListBoxPrenotazioneLaboratorioDTO>(
      ConstantsCLA.PRENOTAZIONE_LABORATORIO_SEARCH_URL,
      command
    );
  }

  creaPrenotazione(objPrenotazione: any, idStudente: number) {
    const command = new AddUpdateStudentePrenotazioneLaboratorioCommand();
    command.idStudente = idStudente;
    command.idLaboratorioLezioneTutoraggio = objPrenotazione.idLaboratorio;
    command.dataLaboratorioLezioneTutoraggio = objPrenotazione.dataLaboratorio;
    return this.http.post<Boolean>(
      ConstantsCLA.CREA_PRENOTAZIONE_LABORATORIO,
      command
    );
  }

  verificaPrenotazioni(objPrenotazione: any, idStudente: number) {
    const command = new AddUpdateStudentePrenotazioneLaboratorioCommand();
    command.idStudente = idStudente;
    command.dataLaboratorioLezioneTutoraggio = objPrenotazione.dataLaboratorio;
    return this.http.post<Boolean>(
      ConstantsCLA.VERIFICA_PRENOTAZIONE_LABORATORIO,
      command
    );
  }
}
